import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { iLocation } from "../../models/Location";
import { useEffect, useState } from "react";
import api from "../../services/axios-client";

const Locations = () => {
  const [locations, setLocations] = useState<iLocation[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchLocations();
  },[]);

  const fetchLocations = async () => {
    try {
      const response = await api.get("/locations");
      if(response.status === 200) setLocations(response.data.locations);
    } catch (error) {
      console.log(error);
    }
  };


  const onDeleteLocation = async (locationId: number) => {

    if(!window.confirm("Are you sure you want to delete this location?")) return;

    try {
      const response = await api.delete(`/locations/${locationId}`);
      if(response.status === 200) fetchLocations();
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
      <div className="content-header pb-6 flex justify-between">
        <div className="content-header-label">Locations</div>
        <div className="content-header-actions">
          <Button onClick={() => { navigate("/location/0"); }}>Add New Location</Button>
        </div>
      </div>
      <div className="content-body">
        <table className="table-auto border w-full">
          <thead>
            <tr>
              <th className="font-bold p-2 border-b text-left w-2">No</th>
              <th className="font-bold p-2 border-b text-left w-full">
                Location Name
              </th>
              <th className="font-bold py-2 px-4 border-b text-left">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {locations.map((location, i) => (
              <tr key={i}>
                <td className="p-2 border-b text-left">{i + 1}</td>
                <td className="p-2 border-b text-left">{location.location_name}</td>
                <td className="py-2 px-4 border-b text-left">
                  <Link to={`/location/${location.location_id}`}>Edit</Link> /{" "}
                  <Button onClick={(e) => {onDeleteLocation(location.location_id);}}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Locations;
